export default __webpack_public_path__ + "static/media/xpensityv2-sm.186742e3.webp";